import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io";
import "./Footer.css";
import LogoMe from "../../assets/logome4.png";
import { BsLinkedin} from "react-icons/bs";


const Footer = () => {
  return (
    <footer id="footer" >
      

      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#service">Service</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Testimonials</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer_socials">
      <a href="https://facebook.com/smichi.jb" target="_blank" rel="noreferrer">
        <FaFacebookF />
      </a>
      <a href="www.linkedin.com/in/smichi" target="_blank" rel="noreferrer">
        <BsLinkedin />{" "}
      </a>
      <a href="https://twitter.com" target="_blank" rel="noreferrer">
        <IoLogoTwitter />
      </a>
      </div>
      <a href="#" className="footer_logo">
        <img src={LogoMe} alt="Smichi Inc" id="logo_image-footer"/>
      </a>
      <div className="footer_copyright">
        <small>&copy; Mahjoub Smichi 2023. All rights reserved.Updated 07-2025</small>
        
      </div>
     
    </footer>
  );
};

export default Footer;
